import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { DecisionTableDefinition } from '@/domains/decisionTables/types/DecisionTableDefinition';

type DecisionTablesState = {
  definitions: DecisionTableDefinition[];
  selectedDefinitionId: string | null;
  isLoading: boolean;
  error: string | null;
};

const initialState: DecisionTablesState = {
  definitions: [],
  selectedDefinitionId: null,
  isLoading: false,
  error: null,
};

const decisionTablesSlice = createSlice({
  name: 'decisionTables',
  initialState,
  reducers: {
    fetchDecisionTables: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchDecisionTablesSuccess: (state, action: PayloadAction<DecisionTableDefinition[]>) => {
      state.definitions = action.payload;
      const selectedDefinitionExists = action.payload.some(
        (definition) => definition.id === state.selectedDefinitionId,
      );
      state.selectedDefinitionId = selectedDefinitionExists
        ? state.selectedDefinitionId
        : (action.payload[0]?.id ?? null);
      state.isLoading = false;
      state.error = null;
    },
    fetchDecisionTablesFailed: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    selectDecisionTable: (state, action: PayloadAction<string>) => {
      state.selectedDefinitionId = action.payload;
    },
  },
});

export const { fetchDecisionTables, fetchDecisionTablesSuccess, fetchDecisionTablesFailed, selectDecisionTable } =
  decisionTablesSlice.actions;

export const decisionTablesReducer = decisionTablesSlice.reducer;
export const decisionTablesReducerPath = decisionTablesSlice.reducerPath;
